import { render } from "./RegistrationView.vue?vue&type=template&id=f58c7c76&scoped=true"
import script from "./RegistrationView.vue?vue&type=script&lang=js"
export * from "./RegistrationView.vue?vue&type=script&lang=js"

import "./RegistrationView.vue?vue&type=style&index=0&id=f58c7c76&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f58c7c76"]])

export default __exports__